/**
 * Source de vérité UNIQUE du badge « ✓ Reçu fiscal » (anti-dérive : avant, la
 * condition était dupliquée sur 4 écrans et ignorait l'activation).
 *
 * Une association n'affiche le badge / ne « délivre un reçu » QUE si :
 *  - elle a explicitement ACTIVÉ l'émission (cerfa_enabled) — engagement pris,
 *  - elle est habilitée (has_cerfa_capability),
 *  - et relève d'un régime éligible (intérêt général 66 % ou aide aux personnes 75 %).
 *
 * (Backfill backend : cerfa_enabled=true pour les assos déjà éligibles → aucun
 * badge existant ne disparaît au déploiement.)
 *
 * Cohérence fiscale (cron task_fiscal_compliance_check) : le badge est en plus
 * MASQUÉ si fiscal_compliance_status vaut "inconsistent" (déclaration incohérente)
 * ou "suspended" (négligence d'émission). Les valeurs "valid", "unchecked" ou
 * absente n'enlèvent PAS le badge (anti-masquage de masse au déploiement / avant
 * le 1er passage du cron — cohérent avec le backfill "valid").
 */
export function associationDeliversReceipt(asso) {
  if (!asso) return false;
  const fc = asso.fiscal_compliance_status;
  if (fc === "inconsistent" || fc === "suspended") return false;
  return (
    !!asso.cerfa_enabled &&
    !!asso.has_cerfa_capability &&
    (asso.fiscal_type === "interet_general" || asso.fiscal_type === "aide_personnes_difficulte")
  );
}

/**
 * Libellés fiscaux — source UNIQUE (décision Lucas 2026-07-11) :
 *  - « RÉDUCTION d'impôt », jamais « déduction » (art. 200 CGI : le don ouvre
 *    droit à une réduction d'impôt — la « déduction » diminue le revenu
 *    imposable, c'est un autre mécanisme ; l'écrire serait inexact).
 *  - Liste publique / fiche / carte : badge SANS montant.
 *  - Tunnel de publication UNIQUEMENT : montant explicite « dès X € de don » —
 *    le « de don » est OBLIGATOIRE (sans lui, un vendeur croit que l'ANNONCE
 *    doit coûter X € — règle UX « utilisateur naïf »).
 */
export const FISCAL_BADGE_LABEL = "Réduction d'impôt";

export function fiscalThresholdEur(asso) {
  const min = Number(asso?.fiscal_receipt_min_amount || 0);
  return Number.isFinite(min) && min > 0 ? Math.round(min * 100) / 100 : 0;
}

export function fiscalBadgeThresholdLabel(asso) {
  const min = fiscalThresholdEur(asso);
  // Seuil 0 (reçu dès le premier euro) → afficher « dès 1 € de don » (plus
  // parlant qu'un « dès 0 € » absurde ; tout don ≥ 1 € ouvre bien droit au reçu).
  const eur = min > 1
    ? (Number.isInteger(min) ? String(min) : min.toFixed(2).replace(".", ","))
    : "1";
  return `${FISCAL_BADGE_LABEL} dès ${eur} € de don`;
}
